export default "__VITE_ASSET__LWon4Tjf__"